import React, { useEffect, useState } from "react";
import PageLayout from "../components/PageLayout";
import SearchHeader from "../components/SearchHeader";
import Complaints from "../components/complaints/Complaints";
import { useLoader } from "../context/LoaderContext";
import { IComplaint } from "../exports/interfaces";
import { fetchComplaints } from "../api/ComplaintApi";
import { dynamicFailed } from "../hooks/useToast";
import { useUser } from "../context/UserContext";

const ComplaintsPage = () => {
  const { setLoading } = useLoader();
  const [complaint, setComplaint] = useState<IComplaint[]>([]);
  const { user } = useUser();
  useEffect(() => {
    if (!user) {
      return;
    }
    Promise.all([fetchComplaints()])
      .then(([complaintData]) => {
        setComplaint(complaintData);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      })
      .catch((error) => {
        dynamicFailed(`${error.message}`);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      });
  }, [setLoading, user]);

  return (
    <PageLayout>
      <SearchHeader />
      <div className="inner-main-content">
        <Complaints complaint={complaint} setComplaint={setComplaint} />
      </div>
    </PageLayout>
  );
};

export default ComplaintsPage;
